export const firmIntakeQuestionKeys = {
  base: ['firm-intake-questions'],
  forFirm: (firmID: string | undefined | null) => [...firmIntakeQuestionKeys.base, firmID],
  forFirmClient: (firmClientID: string | undefined | null) => [
    ...firmIntakeQuestionKeys.base,
    'firm-client',
    firmClientID,
  ],
  responsesForFirmClient: (firmClientID: string | undefined | null) => [
    ...firmIntakeQuestionKeys.base,
    'responses',
    firmClientID,
  ],
};
